import { lazy } from "react";
import { app } from "~/helpers/routes";
import { paths } from "~/router/paths";

const myDrops = lazy(() => import("~/pages/product-drops/my-drops"));
const savedLists = lazy(() => import("~/pages/product-drops/saved-lists"));
const savedListsPreview = lazy(
  () => import("~/pages/product-drops/saved-lists/Preview")
);
const myDropsProductsList = lazy(
  () => import("~/pages/product-drops/my-drops/ProductsList")
);
const myDropsProductDetails = lazy(
  () => import("~/pages/product-drops/my-drops/ProductDetails")
);

export const routes: Array<any> = [
  {
    path: paths.productDrops.myDropsRoot,
    element: app(myDrops),
  },
  {
    path: paths.productDrops.savedListsRoot,
    element: app(savedLists),
  },
  {
    path: paths.productDrops.savedListsPreview,
    element: app(savedListsPreview),
  },
  {
    path: paths.productDrops.myDropsProductsList,
    element: app(myDropsProductsList),
  },
  {
    path: paths.productDrops.myDropsProductDetails,
    element: app(myDropsProductDetails),
  },
];
